module.exports = __webpack_public_path__ + "img/3.cebedcc8.png";